var videoWrapper = document.querySelectorAll(".video-slider__slides.gallery-thumbs");
// console.log(videoWrapper);
videoWrapper.forEach(function (element) {
    var slide = element.querySelectorAll(".video-slider__slide")
    slide.forEach(function (s) {
        var x = s.querySelector("iframe");
        var iframe = s.querySelector("iframe").src,
        regExp = /.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#\&\?]*).*/,
        videoId = iframe.match(regExp);
        var iframeTitle = s.querySelector("iframe").title;
        if (videoId && videoId[1].length === 11) {
            console.log(videoId[1]);
        }
        x.parentNode.removeChild(x);
        var img = s.querySelector(".wp-block-embed__wrapper");
    // img.forEach(function (i) { 
    //     var src = i.querySelector("wp-block-embed__wrapper");

    // });   
        

        var elem = document.createElement("img");
        var title = document.createElement("figcaption");
        var caption = document.createTextNode(iframeTitle);
  elem.setAttribute("src", "//img.youtube.com/vi/" + videoId[1] + "/0.jpg");

        img.appendChild(elem)
        title.appendChild(caption)
        img.appendChild(title)
    });
  });